<template>
  <form @submit.stop.prevent="handleSubmit($event)" class="form"
    :class="{'form--sending':formLoading, 'form--validated': formShowError}"
    v-if="!formSent && !formResponseError"
    novalidate
  >
    <slot></slot>
  </form>
  <FormSuccess v-if="formSent && !formResponseError"
    :title="successTitle"
    :text="successMessage"
    :link="successLink"
    :link_label="successLinkLabel"
  ></FormSuccess>
  <FormError v-model="formResponseError"></FormError>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import recaptcha from '../../helpers/recaptcha';
import { _e } from '../../helpers/l10n';
import FormSuccess from '../sections/FormSuccess.vue';
import FormError from '../sections/FormError.vue';

const emits = defineEmits(['submit','loading']);


const props = defineProps({
  model: {
    type: FormData,
    default: null
  }
});

const formSent = ref(false);
const formLoading = ref(false);
const formShowError = ref(false);
const formResponseError = ref(false);

const successTitle = ref('Formulário enviado com sucesso.');
const successMessage = ref('Recebemos sua mensagem e logo entraremos em contato. Enquanto isso, confira nossas novidades.');
const successLink = ref('#');
const successLinkLabel = ref('Voltar para página de atendimento');

watch(formLoading, (n, o) => {
  emits('loading', n);
});

async function handleSubmit(e) {
  if(e.target.checkValidity()) {
    formShowError.value = false;
    formLoading.value = true;

    const url = _e('api_url');
    const formData = props.model;

    const req = await fetch(url, {
      method: 'POST',
      body: formData
    });

    if(req.ok && req.status < 300) {
      const json = await req.json();

      formSent.value = true;
      formLoading.value = false;
      //TODO: Passar as mensagens para o componente de sucesso?
      successTitle.value = json.title;
      successMessage.value = json.message;
      successLink.value = json.link;
      successLinkLabel.value = json.link_label;

    } else {
      //Deu erro na request
      formResponseError.value = true;
      formLoading.value = false;
    }

  } else {
    formShowError.value = true;
    e.target.reportValidity();
  }
}

</script>
